import { Control, Controller } from 'react-hook-form';
import TextField, { StandardTextFieldProps } from '@mui/material/TextField';

import { Container } from './styles';

export interface InputControlledProps extends StandardTextFieldProps {
  control: Control;
  name: string;
  defaultValue?: any;
}

export const Input = ({
  name,
  control,
  defaultValue = '',
  sx,
  ...rest
}: InputControlledProps) => {
  return (
    <Container sx={sx}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({
          field: { onChange, value, onBlur, ref },
          fieldState: { error },
        }) => (
          <TextField
            value={value}
            onBlur={onBlur}
            onChange={onChange}
            ref={ref}
            error={!!error}
            helperText={error ? error.message : null}
            {...rest}
          />
        )}
      />
    </Container>
  );
};
